import React from "react";
import { ErrorList, ErrorStrings, surveyTypeOptions } from "../../../components/Enums";
import { CustomSelect, ErrorText, PortalFormFieldGroup, PortalFormLabel } from "src/components";
import { SurveySelectOptionContent } from "../DropdownCustomStyles";
import Skeleton from "src/scenes/Statistics/components/Skeleton";

export const TypeOfSurveyField = (props) => {
    const { survey, selectSurveyType, inputErrors, isEditSurveyForm, loading } = props;

    const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
    const surveyTypeError = getErrorStrings(ErrorList.EMPTY_SURVEY_TYPE);

    return (
        <PortalFormFieldGroup>
            <PortalFormLabel>
                Select The Survey Type
            </PortalFormLabel>
            { loading ?
                <Skeleton height="50px" width="100%" animation="wave" />
                :
                <CustomSelect
                    isDisabled={isEditSurveyForm}
                    value={surveyTypeOptions.find(obj => obj.value == survey.surveyType)}
                    placeholder="Please select..."
                    options={ surveyTypeOptions }
                    onChange={(choice) => selectSurveyType(choice)}
                    height="46px"
                    radius="8px"
                    fontSize="0.9375rem"
                    fontWeight={isEditSurveyForm ? 700 : 400}
                    placeholderVariant={isEditSurveyForm ? "muted" : "default"}
                    placeholderFontWeight={isEditSurveyForm ? 500 : 400}
                    renderOption={SurveySelectOptionContent}
                    renderValue={SurveySelectOptionContent}
                />
            }

            { surveyTypeError.length > 0 &&
                <ErrorText errorMargin="15px 20px 15px">
                    {surveyTypeError}
                </ErrorText>
            }
        </PortalFormFieldGroup>
    );
};
